"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _interactions = require("settings-ui-modules/marketing/modules/esp-sync/actions/interactions");

var _handleActions;

var initalState = (0, _immutable.fromJS)({
  openModals: []
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _interactions.InteractionsActionType.CLOSE_MODAL, function (state, action) {
  return state.set('apiKeyModalEspType', null).updateIn(['openModals'], function (modals) {
    return modals.filter(function (modal) {
      return modal !== action.payload.modal;
    });
  });
}), (0, _defineProperty2.default)(_handleActions, _interactions.InteractionsActionType.OPEN_MODAL, function (state, action) {
  return state.updateIn(['openModals'], function (modals) {
    return modals.push(action.payload.modal);
  });
}), _handleActions), initalState);

exports.default = _default;
module.exports = exports.default;